export default __webpack_public_path__ + "static/media/check.89f756b6.svg";